import { useMemo } from 'react'

import { getCookie } from 'cookies-next'

type Options = {
  hideSupportUI?: boolean
}

export const useHideUiForConsumer = (options?: Options) => {
  const workspaceRole =
    typeof window !== 'undefined' ? getCookie('workspace_role') : undefined

  return useMemo(() => {
    if (options?.hideSupportUI !== true) return false

    return workspaceRole !== 'creator' && workspaceRole !== 'manager'
  }, [options?.hideSupportUI, workspaceRole])
}
